module.exports = __webpack_public_path__ + "static/media/hair-makeup-alt.f9e2ef45.svg";